'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivityInspirationCtrl', ActivityInspirationCtrl);

  ActivityInspirationCtrl.$inject = ['$log', '$q', '$state', 'trainSvc', 'activityRouter', 'activitySvc', 'inspiration'];

  /* @ngInject */
  function ActivityInspirationCtrl($log, $q, $state, trainSvc, activityRouter, activitySvc, inspiration) {
    var vm = this;
    vm.title = 'ActivityInspirationCtrl';
    vm.next = next;
    vm.hide = hide;

    activate();

    ////////////////

    function activate() {
      $log.debug('ActivityInspiration control activate');
      vm.inspiration = inspiration;
    }

    function hide(reason) {
      // TODO this should hide ALL inspirations eventually
      activityRouter.skipActivity(vm.inspiration, true, reason);
    }

    function next() {
      trainSvc.setStatus(vm.inspiration, 'COMPLETED');
      activitySvc.saveResponses(vm.inspiration).then(function () {
        activityRouter.navigateTrain();
      });
    }
  }
})();